export const AdminMarketingDashboards = {
  AdminMarketingDashboards: 
  {
    permissionsId: '87d3e2d8-95c3-48e4-ee3f-08da65738802',
    permissionsName: 'Admin Marketing Team',
    componentsId: null,
    components: null
  }
} ;
